import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getActiveSliderItems() {
    const request = axios.get(urls.SLIDER_URL);
  return { type: ActionTypes.GET_ACTIVE_SLIDER_ITEMS, payload: request };
}
